export default function filterReducer(state = "", action){
    console.log(action.type)
    switch(action.type){
        case 'UPDATE_FILTER':
            return action.payload;
        default:
            return state;
    }
}